export default __webpack_public_path__ + "static/media/ExploreIcon.fce5cbcf.svg";